import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Scheduled.module.sass";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Icon from "../../components/Icon";
import Table from "../../components/Table";
import Product from "../../components/Product";
import Loader from "../../components/Loader";
import Panel from "./Panel";

// data
import { UseApi } from "../../hooks/use-api";
import { GetCollections } from "../../Services/lib/nft";
import { Pager } from "../../components/Pager";
import Empty from "../../components/Empty";

const sorting = ["list", "grid"];
export const PageLimit = 12;

const Drafts = () => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [search, setSearch] = useState("");
	const [total, setTotal] = useState(1);
	const [page, setPage_] = useState(1);
	const [data, setData] = useState([]);
	const [filter, setFilter] = useState({
		page: 2,
		limit: PageLimit,
		name: "",
		status: "SCHEDULE",
		order_direction: "ASC",
	});

	const [{ data: res, isLoading }, fetch] = UseApi({
		service: GetCollections,
	});

	const fetchCollections = () => {
		fetch(filter);
	};

	const setPage = (e) => {
		setFilter((p) => {
			return {
				...p,
				page: e,
			};
		});
		setPage_(e);
	};

	useEffect(() => {
		setData([]);
		fetchCollections();
	}, [filter]);

	useEffect(() => {
		if (res) {
			setTotal(Math.ceil(res.list_count / PageLimit));
			setData(res.list);
		}
	}, [res]);

	const props = { total, page, setPage, isLoading };

	const handleSubmit = (e) => {
		e.preventDefault();
		setFilter((p) => {
			return {
				...p,
				name: e.target[0].value,
			};
		});
	};

	const [selectedFilters, setSelectedFilters] = useState([]);

	const handleChange = (id) => {
		if (selectedFilters.includes(id)) {
			setSelectedFilters(selectedFilters.filter((x) => x !== id));
		} else {
			setSelectedFilters((selectedFilters) => [...selectedFilters, id]);
		}
	};

	return (
		<>
			<Card
				className={styles.card}
				classCardHead={styles.head}
				title="Published drops"
				classTitle={cn("title-purple", styles.title)}
				head={
					<>
						<Form
							className={styles.form}
							value={search}
							setValue={setSearch}
							onSubmit={handleSubmit}
							placeholder="Search product"
							type="text"
							name="search"
							icon="search"
						/>
						{/* <div className={styles.sorting}>
							{sorting.map((x, index) => (
								<button
									className={cn(styles.link, {
										[styles.active]: index === activeIndex,
									})}
									onClick={() => setActiveIndex(index)}
									key={index}
								>
									<Icon name={x} size="24" />
								</button>
							))}
						</div> */}
					</>
				}
			>
				<div className={styles.wrapper}>
					{activeIndex === 0 && (
						<Table
							items={data}
							title="Scheduled for"
							{...props}
							fetchCollections={fetchCollections}
						/>
					)}
					{activeIndex === 1 && (
						<>
							<div className={styles.list}>
								{isLoading && <Loader className={styles.loader} />}
								{!isLoading && data.length === 0 && <Empty />}
								{data.map((x) => (
									<Product
										className={styles.product}
										value={selectedFilters.includes(x._id)}
										onChange={() => handleChange(x._id)}
										item={x}
										key={x._id}
										released
									/>
								))}
							</div>
							<div className={styles.foot}>
								<Pager {...props} />
							</div>
						</>
					)}
				</div>
			</Card>
			{/* <Panel /> */}
		</>
	);
};

export default Drafts;
